@use "../../../../../../../../styles/Colors.scss" as Colors;
@use "../../../../../../../../styles/Constants.scss" as Constants;

$var-shadow: 0 2px 2px 0 Colors.$col-shadow;
$var-border: 1px solid Colors.$col-greyConnection;
$var-dot-icon-size: 6px;

.gap {
	width: 2px;
}

.section-container {
	width: var(--widthPercentage);
	height: 100%;
	position: relative;

	&__fill-background {
		background-color: Colors.$col-white;
	}

	&__bar-container {
		display: flex;
		flex-direction: column;
		width: 100%;

		&--gap {
			margin-right: 2px;
		}
	}

	&__icon-container {
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		padding-top: 4px;
	}
}

.section {
	height: 8px;
	border-right: 1px solid Colors.$col-white;
	z-index: 2;

	&__icon {
		display: flex;
		justify-content: center;
		font-size: Constants.$val-fontSizeBig;
		margin-bottom: Constants.$val-spacing-xs;
		width: 16px;
		height: 16px;
		color: Colors.$col-blue;
		z-index: 2;
		
		&.unsigned-manual {
			color: Colors.$col-orange;
			background-color: white;
		}

		&.si-signed {
			color: Colors.$col-green;
			background-color: white;
		}

		&.overlap {
			color: Colors.$col-canceledRed;
			background-color: white;
		}
	}

	&__duration {
		display: flex;
		justify-content: center;
		font-weight: bold;
		margin-top: Constants.$val-spacing-xs;
	}

	&.entry {
		background-color: Colors.$col-blue;
	}

	&.occupied {
		background-color: Colors.$col-greyFontLight;
	}

	&.unsigned-manual {
		background-color: Colors.$col-orange;
	}

	&.si-signed {
		background-color: Colors.$col-green;
	}

	&.overlap {
		background-color: Colors.$col-canceledRed;
	}

	&.rounded-left {
		border-top-left-radius: 4px;
		border-bottom-left-radius: 4px;
	}

	&.rounded-right {
		border-top-right-radius: 4px;
		border-bottom-right-radius: 4px;
	}
}
